import src from "IMAGE";
export default { src, width: 179, height: 35, blurWidth: 0, blurHeight: 0};
